// import React from 'react'

// const PaymentDetails = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default PaymentDetails


import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Grid,
  CircularProgress,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useLocation } from "react-router-dom";
import { COMPANY_API_01, LICENSE_API_03 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { useSelector } from "react-redux";
import currencyFormat from "../../utils/common/CurrencyFormat";
import { CON_STATUS_ACTIVE, CON_STATUS_PENDING } from "../../utils/sys/Constants";
const PaymentDetails = () => {
      const [data, setData] = useState(null);
      const [error, setError] = useState(null);
      
        const [filteredData, setFilteredData] = useState(null);
        const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const SYS_USER = useSelector((state) => state.user) || {};
    const { COMPCODE, LOCCODE, BUSINESSTYPECODE } = SYS_USER.USER_PARAM || {};
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("paymentId");
  const actionText = queryParams.get("actionText");
  const handlePrint = () => {
    window.print();
  };
 const [details, setDetails] = useState(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LICENSE_API_03, "get", {
         COMPCODE,
         
         PAYMENTID:paymentId,
        });
        setData(result);
        console.log("result",result)
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [COMPCODE,]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetching company details with specified parameters
        const result = await externalgetApi(COMPANY_API_01, "get", {
          COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });
        console.log("company", result);
        // Assuming the API returns an array and we want the first item
        if (result) {
          setDetails(result[0]);
          console.log("result", result);
        } else {
          setError("No data found");
        }
        setIsLoading(false);
      } catch (err) {
        setError(err.message || "Error fetching data");
      }
    };

    fetchData();
  }, []);

  
  const formatDate = (timestamp) => {
    return timestamp.split('T')[0];
  };

  return (
   

    <Box sx={{ padding: 4, maxWidth: 800, margin: "auto", }}>
     
       <Box
  sx={{
    textAlign: "right", // Align the content to the right
    mt: 4,
    p: 2, // Add some padding to the right side
    "@media print": {
      display: "none", // Hide the button when printing
    },
  }}
>
  <Button
    variant="contained"
    color="primary"
    startIcon={<PrintIcon />}
    onClick={handlePrint}
    sx={{
       
        textTransform: "capitalize",
        width: "80px",
       
      }}
  >
    Print
  </Button>
</Box>
{ data && data.length > 0 ? (
 data.map((row, index) => (
      <Paper elevation={3}  sx={{ border: '2px solid #000', padding: 8, display: 'inline-block' }}>
        {/* Invoice Details */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" align="center" fontWeight='bold'>
              Invoice Details
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
            {/* {details.COMPNAME}<br />
            {details.COMPADDRESS1 }, <br />
            {details.COMPADDRESS2}, <br />
            {details.COMPADDRESS3}. <br /> */}

No 108A, 3/1, (3rd Floor)  <br />
Maya Avenue, Colombo 06,  <br />
Sri Lanka.         <br />
VAT Registration Number : GB570145265         <br />
        
             
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
            {/* Payment ID: {paymentId}<br /> */}
              Invoice Number: <strong>{row.INVOICENO}</strong> <br />
              Total: <strong>{currencyFormat(row.NETTVALUE)}</strong> <br />
              Invoice Date: <strong>{row.NEXTDUEDATE}</strong> <br />
              Status:<strong>
  {row.STS === CON_STATUS_PENDING ? "Unpaid" : row.STS === CON_STATUS_ACTIVE ? "Paid" : row.STS}
</strong>

            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Biller Details */}
        <Typography variant="h6" sx={{ mb: 1 }}>
          Biller Details
        </Typography>
        <Typography>

 {row.COMPNAME} <br />
    {row.COMPADDRESS1}  <br />
      {row.COMPADDRESS2}   <br />
    {row.COMPADDRESS3}  <br />
 {row.EMAIL}  <br />
  {row.HOTLINE}
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* Item Details */}
        <Typography variant="h6" sx={{ mb: 1,fontWeight: 'bold' }}>
          Item Details
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: 'bold' }}>Item</TableCell>
              
                <TableCell align="right" sx={{fontWeight: 'bold' }}>Addon Value</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>License Value</TableCell>
                <TableCell align="right" sx={{  fontWeight: 'bold' }}>Due Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              
                <TableRow key={index}>
                  <TableCell>{row.REMARK}</TableCell>
                  <TableCell align="right">{currencyFormat(row.ADDONVALUE)}</TableCell>
               
                  <TableCell align="right">{currencyFormat(row.LICENSEVALUE)}</TableCell>
                  <TableCell align="right">{currencyFormat(row.GROSSVALUE)}</TableCell>
                </TableRow>
            
            </TableBody>
          </Table>
        </TableContainer>


        <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
  <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
  Total Invoice: 
  </Typography>
  <Box sx={{ border: '2px solid #000', padding: 1, display: 'inline-block' }}>
  <Typography variant="h6" align="right" sx={{ mt: 0, fontWeight: 'bold' }}>
    LKR  {currencyFormat(row.NETTVALUE)}
    </Typography>
</Box>

</Box>

        <Divider sx={{ my: 2 }} />
        <Box display="flex" justifyContent="space-between" alignItems="center">
  <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold' }}>
    Period for Subscription
  </Typography>
  <Typography variant="h6" align="right" sx={{ mt: 2, fontWeight: 'bold' }}>
    {formatDate(row.DUEFROMDATE)} - {formatDate(row.DUETODATE)}
  </Typography>
</Box>

        
        

        <Divider sx={{ my: 2 }} />

        {/* Footer Notes */}
        <Typography variant="body2">
          For subscriptions, your payment is charged monthly/annually at the
          current list price until you cancel. If you have a discount, it will
          apply to the then-current list price until it expires. <br />
          <br />
          For one-time services, your payment method on file will reflect the
          charge in the amount referenced in this invoice. Terms, conditions,
          pricing, features, service, and support options are subject to change
          without notice. <br />
          <br />
          All dates and times are Sri Lanka Standard Time (IST).
        </Typography>
      </Paper>

    
     
))
) : (
  <Box
           sx={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             minHeight: "60vh",
           }}
         >
           <CircularProgress color="primary" />
         </Box>
)}
    </Box>

  );
};

export default PaymentDetails;

